import React from "react";
import { IconProfile, IconSettings, IconSignOut, IconClose } from "./CricketIcons";

interface Props {
  userName: string;
  userEmail?: string;
  onClose: () => void;
  onProfile: () => void;
  onSettings: () => void;
  onSignOut: () => void;
}

export default function AccountMenu({ userName, userEmail, onClose, onProfile, onSettings, onSignOut }: Props) {
  const handle = (action: () => void) => {
    onClose();
    action();
  };

  const initials = (userName || "P").slice(0, 2).toUpperCase();

  return (
    <div className="fixed inset-0 bg-black/60 z-[9998]" onClick={onClose}>
      <div
        className="fixed right-0 top-0 h-full w-72 overflow-y-auto z-[9999] shadow-2xl"
        style={{
          background: "linear-gradient(180deg, #0a0f0d 0%, #0d1512 100%)",
          borderLeft: "1px solid rgba(255,255,255,0.08)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Compact header with user info */}
        <div className="px-5 py-4" style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
              style={{ background: "rgba(0,201,128,0.15)", border: "1px solid rgba(0,201,128,0.2)", color: "#00C980" }}
            >
              {initials}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-white truncate leading-tight">{userName}</p>
              {userEmail && (
                <p className="text-xs text-slate-400 truncate mt-0.5 break-all leading-tight">{userEmail}</p>
              )}
            </div>
            <button
              onClick={onClose}
              className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-colors flex-shrink-0"
              aria-label="Close"
            >
              <IconClose className="w-5 h-5" />
            </button>
          </div>
        </div>

        <nav className="p-3">
          <MenuButton icon={<IconProfile className="w-5 h-5" />} label="My Profile" onClick={() => handle(onProfile)} />
          <MenuButton icon={<IconSettings className="w-5 h-5" />} label="Account Settings" onClick={() => handle(onSettings)} />
          <div className="my-2 mx-4" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }} />
          <button
            onClick={() => handle(onSignOut)}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-red-400 transition-colors duration-150 hover:bg-red-500/10"
          >
            <span><IconSignOut className="w-5 h-5" /></span>
            <span>Sign Out</span>
          </button>
        </nav>
      </div>
    </div>
  );
}

function MenuButton({
  icon,
  label,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-white transition-colors duration-150 hover:bg-white/5"
    >
      <span className="text-slate-300">{icon}</span>
      <span>{label}</span>
    </button>
  );
}
